export const idGenerator = function* (prefix) {
  let count = 0;
  while (true) {
    yield `${prefix}-${count}`;
    count++;
  }
};
